export enum SHAPE_ENUM {
    RECT = 'rect',
    ELLIPSE = 'ellipse',
    LINE = 'line',
}
export type Shape = `${SHAPE_ENUM}`;

export interface IBaseSvgInfo {
    /** 形状 */
    shape: string;

    /**填充颜色 */
    fill: string;
    /**
     *  边框颜色
     */
    stroke: string;
    /**
     *  边框线宽
     */
    'stroke-width': number;
}

export interface IRectInfo extends IBaseSvgInfo {
    /**x坐标 */
    x: number;
    /**y坐标 */
    y: number;
    width: number;
    height: number;
    /**水平圆角半径 */
    rx: number;
    /**垂直圆角半径 */
    ry: number;
}

export interface IEllipseInfo extends IBaseSvgInfo {
    /**水平圆心点 */
    cx: number;
    /**垂直圆心点  */
    cy: number;
    /**水平半径 */
    rx: number;
    /**垂直半径  */
    ry: number;
}
export interface ILineInfo extends IBaseSvgInfo {
    x1: number;
    y1: number;
    x2: number;
    y2: number;
}

export interface ISvgInfo {
    rect: IRectInfo;
    ellipse: IEllipseInfo;
    line: ILineInfo;
}

export enum SVG_ATTR_ENUM {
    X = 'x',
    Y = 'y',
    FILL = 'fill',
    STROKE_COLOR = 'stroke',
    STROKE_WIDTH = 'stroke_width',
    WIDTH = 'width',
    HEIGHT = 'height',
    RX = 'rx',
    RY = 'ry',
    CX = 'cx',
    CY = 'cy',
    R = 'r',
    X1 = 'x1',
    Y1 = 'y1',
    X2 = 'x2',
    Y2 = 'y2',
    SHAPE = 'shape',
}
